import { BaseApi } from "../base";

// NOT WORKING: We need to discuss scopes with Global Accounts team.
export default class LivechatApi extends BaseApi {
  protected readonly service = "livechat";
  protected readonly prefix = "v2";

  fetchGroups = this.get("properties/groups");
}
